import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';
import {mapMbSharedSubPath} from './mb-shared-subpaths';

// Runs on the outer /media-blast-mobile route, before the lazy module's AuthenticationGuard,
// so it decides where a mobile->desktop switch lands.
export const MobileOnlyGuard: CanActivateFn = (_route, state) => {
  const deviceService = inject(DeviceDetectorService);
  const router = inject(Router);
  const isMobile = !deviceService.isDesktop() && !deviceService.isTablet();
  if (!isMobile) {
    return router.parseUrl(mapMbSharedSubPath(state.url, '/media-blast-mobile', '/media-blast') || '/media-blast');
  }
  return true;
};
